import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin as apiLogin, adminMe } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null); // null = checking, false = logged out, obj = logged in
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    const token = localStorage.getItem("pickauto_admin_token");
    if (!token) {
      setAdmin(false);
      setLoading(false);
      return;
    }
    try {
      const me = await adminMe();
      setAdmin(me);
    } catch {
      localStorage.removeItem("pickauto_admin_token");
      setAdmin(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const res = await apiLogin(email, password);
    localStorage.setItem("pickauto_admin_token", res.access_token);
    const me = await adminMe();
    setAdmin(me);
    return me;
  };

  const logout = () => {
    localStorage.removeItem("pickauto_admin_token");
    setAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
